export default __webpack_public_path__ + "static/media/tenant2.d0e7691b.png";